import { Component, computed, input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  featherChevronDown,
  featherChevronLeft,
  featherChevronRight
} from '@ng-icons/feather-icons';

import { Breadcrumb } from '@app/core/services/breadcrumb.service';
import { OverlayDirective } from '@app/core/ui/directives/overlay/overlay.directive';

@Component({
  selector: 'mw-breadcrumb',
  standalone: true,
  imports: [NgIconComponent, OverlayDirective, RouterModule],
  providers: [
    provideIcons({
      featherChevronDown,
      featherChevronLeft,
      featherChevronRight
    })
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  host: {
    class: 'contents'
  }
})
export class BreadcrumbComponent {
  readonly breadcrumbs = input.required<Breadcrumb[]>();
  readonly size = input<'sm' | 'md' | 'lg'>('sm');

  protected readonly ancestorMenuOpen = signal(false);

  protected readonly ancestorBreadcrumbs = computed((): Breadcrumb[] => {
    const items = this.breadcrumbs();
    return items.length > 1 ? items.slice(0, -1) : [];
  });

  protected readonly ancestorMenuItems = computed((): Breadcrumb[] => {
    return [...this.ancestorBreadcrumbs()].reverse();
  });

  protected readonly hasNavigableAncestors = computed(
    () => this.ancestorBreadcrumbs().length > 0
  );

  protected readonly showAncestorDropdown = computed(
    () => this.ancestorBreadcrumbs().length > 1
  );

  protected readonly currentBreadcrumb = computed((): Breadcrumb | null => {
    const items = this.breadcrumbs();
    return items.length ? items[items.length - 1] : null;
  });

  protected readonly parentBreadcrumb = computed((): Breadcrumb | null => {
    const items = this.breadcrumbs();
    return items.length > 1 ? items[items.length - 2] : null;
  });

  protected toggleAncestorMenu(): void {
    this.ancestorMenuOpen.update((open) => !open);
  }

  protected closeAncestorMenu(): void {
    this.ancestorMenuOpen.set(false);
  }
}
